import { render, staticRenderFns } from "./PlayerCardsList.vue?vue&type=template&id=b6b89028&scoped=true&"
import script from "./PlayerCardsList.vue?vue&type=script&lang=js&"
export * from "./PlayerCardsList.vue?vue&type=script&lang=js&"
import style0 from "./PlayerCardsList.vue?vue&type=style&index=0&id=b6b89028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b89028",
  null
  
)

export default component.exports